import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 60%;
	margin: 80px auto;
	@media screen and (max-width: 1000px) {
		width: 95%;
	}
`;

export const TopButton = styled.div`
	position: fixed;
	bottom: 40px;
	right: 60px;
	background: #f7f7f7;
	width: 55px;
	height: 55px;
	border-radius: 50%;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	-webkit-box-pack: center;
	justify-content: center;
	cursor: pointer;
	user-select: none;
	box-shadow: #00000066 0px 0px 20px;
	z-index: 99;
	padding-bottom: 3px;
	svg {
		width: 20px;
		height: 20px;
		fill: #03a4ec;
		rotate: 180deg;
	}
	@media screen and (max-width: 700px) {
		right: 10px;
		bottom: 20px;
	}
`;
